import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	popOver: {
		backgroundColor        : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey : theme.other.paletteNew.primaryBackgroundGrey,
		borderRadius           : "20px",
		border                 : "none",
		zIndex                 : 100,
		overflowY              : "scroll",
		boxShadow              : "0 0 40px 10px rgba(0, 0, 0, 0.1)",
		padding                : ( props?.searchTerm?.length > 2 ) ? "0" : "2rem",
		display                : "block",
		"&::-webkit-scrollbar" : {
			width      : "0", /* Remove scrollbar space */
			height     : "0",
			background : "transparent" /* Optional: just make scrollbar invisible */
		},
		top: "65px !important"
	},

	backIcon: {
		height      : "2rem",
		width       : "2rem",
		marginRight : "1rem"
	},

	mobileSearchContainer: {
		display        : "flex",
		justifyContent : "center",
		padding        : "1.6rem",
		background     : theme.other.colors.background.tertiary,
		alignItems     : "center"
	}
} ), { name: "results-mobile" } );